const API_PATHS = {
    ROOT: '/api',
    MGMT_ROOT: '/mgmt-api',

    // User
    CREATE_USER(userId) {
        return `${this.ROOT}/createUser/${userId}`
    },
    GET_USER(userId) {
        return `${this.ROOT}/getUser/${userId}`
    },
    UPDATE_USER(userId) {
        return `${this.ROOT}/updateUser/${userId}`
    },
    DELETE_USER(userId) {
        return `${this.ROOT}/deleteUser/${userId}`
    },
    
    // User Preferences
    CREATE_USER_PREFERENCE(userId) {
        return `${this.ROOT}/createUserPreference/${userId}`
    },
    GET_USER_PREFERENCE(userId, preferenceKey) {
        return `${this.ROOT}/getUserPreference/${userId}/${preferenceKey}`
    },
    GET_USER_PREFERENCES(userId) {
        return `${this.ROOT}/getUserPreferences/${userId}`
    },
    UPDATE_USER_PREFERENCE(userId, preferenceKey) {
        return `${this.ROOT}/updateUserPreference/${userId}/${preferenceKey}`
    },
    DELETE_USER_PREFERENCE(userId, preferenceKey) {
        return `${this.ROOT}/deleteUserPreference/${userId}/${preferenceKey}`
    },
    DELETE_USER_PREFERENCES(userId) {
        return `${this.ROOT}/deleteUserPreference/${userId}`
    },

    // User Events
    CREATE_USER_EVENT(userId) {
        return `${this.ROOT}/createUserEvent/${userId}`
    },
    GET_USER_EVENTS(userId) {
        return `${this.ROOT}/getUserEvents/${userId}`
    },
    UPDATE_USER_EVENT(userId, eventId) {
        return `${this.ROOT}/updateUserEvent/${userId}/${eventId}`
    },

    // Account
    CREATE_ACCOUNT(userId) {
        return `${this.ROOT}/createAccount/${userId}`
    },
    GET_ACCOUNT(userId, id) {
        return `${this.ROOT}/getAccount/${userId}/${id}`
    },
    GET_ACCOUNTS(userId) {
        return `${this.ROOT}/getAccounts/${userId}`
    },
    GET_ACCOUNTS_GROUPED_BY_TYPE(userId) {
        return `${this.ROOT}/getAccountsGroupedByType/${userId}`
    },
    UPDATE_ACCOUNT(userId) {
        return `${this.ROOT}/updateAccount/${userId}`
    },
    DELETE_ACCOUNT(userId, id) {
        return `${this.ROOT}/deleteAccount/${userId}/${id}`
    },

    // Debt Account
    CREATE_DEBT_ACCOUNT(userId) {
        return `${this.ROOT}/createDebtAccount/${userId}`
    },
    GET_DEBT_ACCOUNT(userId, id) {
        return `${this.ROOT}/getDebtAccount/${userId}/${id}`
    },
    GET_DEBT_ACCOUNTS(userId) {
        return `${this.ROOT}/getDebtAccounts/${userId}`
    },
    UPDATE_DEBT_ACCOUNT(userId) {
        return `${this.ROOT}/updateDebtAccount/${userId}`
    },

    // Account Balance
    GET_INCLUDED_ACCOUNT_BALANCES(userId) {
        return `${this.ROOT}/getIncludedAccountBalances/${userId}`
    },

    // Transaction
    CREATE_TRANSACTION(userId) {
        return `${this.ROOT}/createTransaction/${userId}`
    },
    GET_TRANSACTION(userId, id) {
        return `${this.ROOT}/getTransaction/${userId}/${id}`
    },
    GET_TRANSACTIONS(userId) {
        return `${this.ROOT}/getTransactions/${userId}`
    },
    GET_SNOWBALL_TRANSACTION_IDS(userId) {
        return `${this.ROOT}/getSnowballTransactionIds/${userId}`
    },
    UPDATE_TRANSACTION(userId, id) {
        return `${this.ROOT}/updateTransaction/${userId}/${id}`
    },
    SET_TRANSACTION_ACCOUNT_TO_NULL_BY_ACCOUNT_ID(userId, id) {
        return `${this.ROOT}/setTransactionAccountToNullByAccountId/${userId}/${id}`
    },
    CREATE_SNOWBALL_DATA(userId) {
        return `${this.ROOT}/createSnowballData/${userId}`
    },
    GET_SNOWBALL_DATA(userId) {
        return `${this.ROOT}/getSnowballData/${userId}`
    },
    DELETE_TRANSACTION(userId, id) {
        return `${this.ROOT}/deleteTransaction/${userId}/${id}`
    },
    DELETE_SNOWBALL_TRANSACTIONS(userId) {
        return `${this.ROOT}/deleteSnowballTransactions/${userId}`
    },
    DELETE_TRANSACTION_PATTERN(userId, id) {
        return `${this.ROOT}/deletePattern/${userId}/${id}`
    },
    GET_TRANSACTION_TEMPLATES() {
        return `${this.ROOT}/getTransactionTemplates/`
    },

    // Exception
    CREATE_EXCEPTION(userId, id) {
        return `${this.ROOT}/createException/${userId}/${id}`
    },
    GET_EXCEPTION(userId, id) {
        return `${this.ROOT}/getException/${userId}/${id}`
    },
    GET_EXCEPTIONS(userId) {
        return `${this.ROOT}/getExceptions/${userId}`
    },
    GET_EXCEPTIONS_BY_TRANSACTION_ID(userId, id) {
        return `${this.ROOT}/getExceptionsByTransactionId/${userId}/${id}`
    },
    DELETE_EXCEPTION(userId, id) {
        return `${this.ROOT}/deleteException/${userId}/${id}`
    },
    DELETE_ALL_EXCEPTIONS_BY_TRANSACTION_ID(userId, id) {
        return `${this.ROOT}/deleteAllExceptionsByTransactionId/${userId}/${id}`
    },


    // OPEN BANKING CUSTOMER

    CREATE_OB_CUSTOMER(userId) {
        return `${this.ROOT}/createOBCustomer/${userId}`
    },
    GET_OB_CUSTOMER(userId) {
        return `${this.ROOT}/getOBCustomer/${userId}`
    },
    UPDATE_OB_CUSTOMER(userId) {
        return `${this.ROOT}/updateOBCustomer/${userId}`
    },
    DELETE_OB_CUSTOMER(userId) {
        return `${this.ROOT}/deleteOBCustomer/${userId}`
    },

    // OPEN BANKING CUSTOMER ACCOUNT

    CREATE_OB_CUSTOMER_ACCOUNT(userId) {
        return `${this.ROOT}/createOBCustomerAccount/${userId}`
    },
    GET_OB_CUSTOMER_ACCOUNT(userId, customerId, accountId) {
        return `${this.ROOT}/getOBCustomerAccount/${userId}/${customerId}/${accountId}`
    },
    GET_OB_CUSTOMER_ACCOUNTS(userId, customerId) {
        return `${this.ROOT}/getOBCustomerAccounts/${userId}/${customerId}`
    },
    UPDATE_OB_CUSTOMER_ACCOUNT(userId) {
        return `${this.ROOT}/updateOBCustomerAccount/${userId}`
    },
    DELETE_OB_CUSTOMER_ACCOUNT(userId, accountId) {
        return `${this.ROOT}/deleteOBCustomerAccount/${userId}/${accountId}`
    },

    // PLAID - ITEM

    CREATE_PLAID_ITEM(userId) {
        return `${this.ROOT}/createPlaidItem/${userId}`
    },
    GET_PLAID_ITEM(userId, itemId) {
        return `${this.ROOT}/getPlaidItem/${userId}/${itemId}`
    },
    GET_PLAID_ITEMS(userId) {
        return `${this.ROOT}/getPlaidItems/${userId}`
    },
    UPDATE_PLAID_ITEM(userId) {
        return `${this.ROOT}/updatePlaidItem/${userId}`
    },
    DELETE_PLAID_ITEM(userId, itemId) {
        return `${this.ROOT}/deletePlaidItem/${userId}/${itemId}`
    },

    // PLAID - ACCOUNT

    CREATE_PLAID_ACCOUNT(userId) {
        return `${this.ROOT}/createPlaidAccount/${userId}`
    },
    GET_PLAID_ACCOUNT(userId, accountId) {
        return `${this.ROOT}/getPlaidAccount/${userId}/${accountId}`
    },
    GET_PLAID_ACCOUNTS(userId) {
        return `${this.ROOT}/getPlaidAccounts/${userId}`
    },
    UPDATE_PLAID_ACCOUNT(userId) {
        return `${this.ROOT}/updatePlaidAccount/${userId}`
    },
    DELETE_PLAID_ACCOUNT(userId, accountId) {
        return `${this.ROOT}/deletePlaidAccount/${userId}/${accountId}`
    },

    // MANAGEMENT API

    GET_AUTH0_USER(userId) {
        return `${this.MGMT_ROOT}/v2/users/${userId}`
    },
    SEND_VERIFICATION_EMAIL(userId) {
        return `${this.MGMT_ROOT}/api/v2/jobs/verification-email/${userId}`
    },

    // SUPPORT
    SEND_SUPPORT_EMAIL() {
        return `/support-email`
    }
}

export default API_PATHS
